<template>
  <step-container
    :number="stepNumber"
    title="¿Cuál es la ocasión del regalo?"
    :auto-scroll="false"
  >
    <div class="flex flex-wrap justify-center gap-6 md:gap-8 max-w-[600px] mb-4">
      <label
        v-for="(element, index) in motives"
        :id="`motive-${index}`"
        :key="index"
        class="rounded-full px-3 md:px-5 py-1 md:py-2 border-2 justify-center items-center gap-2 md:gap-4 inline-flex cursor-pointer duration-150 ease-in-out"
        :class="{
          'hover:scale-[1.02] hover:shadow': true, //hovered
          'has-[:focus-visible]:scale-[1.02] has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-stone-700 has-[:focus-visible]:ring-offset-4': true, //focused
          'border-pink-700 shadow-pink-200 shadow': option === element.value,
          'border-zinc-200': option !== element.value,
        }"
        :for="`motive-option-${index}`"
        :aria-owns="`motive-option-${index}`"
        :aria-checked="option === element.value"
        :aria-label="element.title"
        role="radio"
        :name="stepNumber"
      >
        <span class="text-lg md:text-2xl">{{ element.icon }}</span>
        <span class="md:text-lg">{{ element.title }}</span>
        <span
          class="flex bg-opacity-0 bg-pink-700 transition-all duration-300 size-5 border-2 rounded-full"
          :class="{
            'bg-opacity-100 border-pink-700': option === element.value,
            'border-stone-300': option !== element.value,
          }"
        >
          <input
            :id="`motive-option-${index}`"
            type="radio"
            class="opacity-0 absolute"
            :value="element.value"
            v-model="option"
            :tabindex="(index === 0 && !option) || option === element.value ? '0' : '-1'"
            :name="stepNumber"
          />
          <img
            :src="checkIcon"
            width="12"
            height="12"
            class="inline-block text-center mx-auto"
            aria-hidden="true"
          />
        </span>
      </label>
    </div>
  </step-container>
</template>

<script setup>
import checkIcon from "@assets/images/icons/check.svg";
</script>
<script>
import stepMixin from "../../mixins/step";
import optionMixin from "../../mixins/option";

export default {
  mixins: [stepMixin, optionMixin],

  props: ["motives"],
};
</script>
